<template>
  <div class="login-page">
    <!-- 登录卡片容器 -->
    <el-card class="login-card">
      <div class="login-title">手机号授权登录</div>
      <!-- 手机号输入框 -->
      <el-form
        ref="loginFormRef"
        :model="loginForm"
        :rules="loginRules"
        label-width="0"
        class="login-form"
      >
        <el-form-item prop="phone">
          <el-input
            v-model="loginForm.phone"
            placeholder="请输入授权手机号"
            type="tel"
            clearable
            prefix-icon="el-icon-phone"
            class="phone-input"
          />
        </el-form-item>
      </el-form>
      <!-- 登录按钮 -->
      <el-button
        type="primary"
        size="large"
        class="login-btn"
        :loading="isLoading"
        @click="handleLogin"
      >
        登录授权
      </el-button>
    </el-card>
  </div>
</template>

<script>
import { login } from "@/api/api";
export default {
  name: "LoginPage",
  data() {
    return {
      // 登录表单数据
      loginForm: {
        phone: "", // 绑定手机号输入框
      },
      // 表单校验规则
      loginRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号格式",
            trigger: "blur",
          },
        ],
      },
      isLoading: false, // 按钮加载状态，防止重复点击
    };
  },
  // 页面挂载后尝试从 cookie 的 token 中解析手机号并填入表单
  mounted() {
    try {
      const match = document.cookie.match("(?:^|; )token=([^;]*)");
      const token = match ? decodeURIComponent(match[1]) : null;
      if (token) {
        const parts = token.split('.');
        if (parts.length >= 2) {
          // JWT 的 payload 是 base64url 编码，先转换为标准 base64
          const payload = parts[1];
          const b64 = payload.replace(/-/g, '+').replace(/_/g, '/');
          // atob 返回字符串，可能包含非 UTF-8 字符，需要处理解码
          const jsonStr = decodeURIComponent(atob(b64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          }).join(''));
          const obj = JSON.parse(jsonStr);
          if (obj && obj.phone) {
            this.loginForm.phone = obj.phone;
          }
        }
      }
    } catch (err) {
      // 解析失败时不影响页面使用
      console.error('解析 token 失败：', err);
    }
  },
  methods: {
    // 登录按钮点击事件
    async handleLogin() {
      // 先做表单校验
      const valid = await this.$refs.loginFormRef.validate().catch(() => false);
      if (!valid) return; // 校验失败直接返回

      // 校验成功，设置加载状态
      this.isLoading = true;
      try {
        // 此处写实际的登录请求逻辑（替换为你的接口）
        const result = await login(this.loginForm.phone);
        console.log("手机号授权登录：", this.loginForm.phone, result);
        this.$message.success("登录授权成功！");
        // 登录成功后跳转到首页
        this.$router.push("/");
      } catch (error) {
        // 登录失败处理：尝试从服务端返回中展示更详细的 data 信息
        let extra = "";
        // 如果拦截器抛出的是 resp 对象（我们在 request.js 中这样处理），它的结构为 resp.data
        if (error && error.data) {
          // 优先展示 data 字段
          if (error.data.data !== undefined) {
            extra = error.data.data;
          } else if (error.data.msg) {
            extra = error.data.msg;
          }
        } else if (error && error.response && error.response.data) {
          // axios 的错误对象中可能包含 response
          const d = error.response.data;
          if (d.data !== undefined) extra = d.data;
          else if (d.msg) extra = d.msg;
        } else if (error && error.message) {
          extra = error.message;
        }
        const content = extra ? `登录授权失败：${typeof extra === "string" ? extra : JSON.stringify(extra)}` : "登录授权失败，请稍后重试";
        this.$message.error(content);
      } finally {
        // 无论成功失败，关闭加载状态
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="css">
/* 页面整体样式：居中、背景浅灰 */
.login-page {
  width: 100vw;
  height: 100vh;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 20px;
}
/* 登录卡片样式：固定宽度、内边距 */
.login-card {
  width: 100%;
  max-width: 400px;
  padding: 30px 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
/* 登录标题 */
.login-title {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}
/* 表单样式 */
.login-form {
  margin-bottom: 20px;
}
/* 手机号输入框样式 */
.phone-input {
  width: 100%;
  height: 48px;
  font-size: 16px;
}
/* 登录按钮样式 */
.login-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
}
</style>